// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__35Zns","buttons":"RemoveExpirationActionButtons_buttons__LVRTY"};